var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetchJSON from "./fetch-json";
class RequestManager {
    static makeRequest(path, options, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            const fullUrl = this.appendShareKey(path);
            return this._request(path, fullUrl, options, cb);
        });
    }
    static makeAccountRequest(path, options, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            const fullPath = this.accountUrl(path);
            const fullUrl = this.appendShareKey(fullPath);
            return this._request(fullPath, fullUrl, options, cb);
        });
    }
    static makeExternalRequest(url, options, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._request(url, url, options, cb);
        });
    }
    static _request(requestKey, url, options, cb) {
        return __awaiter(this, void 0, void 0, function* () {
            this.onRequestCallbacks.forEach((fn) => fn(url));
            const request = this.onIdle(() => fetchJSON(url, options));
            const onDone = () => this.onRequestDone(requestKey);
            let promise;
            if (typeof cb === "function") {
                promise = request.then(cb).finally(onDone);
            }
            else {
                promise = request.finally(onDone);
            }
            this.inFlightRequests.set(requestKey, promise);
            return promise;
        });
    }
    static accountUrl(path) {
        return `${window.SPEEDCURVE_CONFIG.accountUrl}${path}`;
    }
    static appendShareKey(path) {
        const url = new URL(path, window.location.origin);
        if (window.beingShared && window.share) {
            // For share mode sessions, append the share key to ensure all requests are authenticated
            url.searchParams.set("share", window.share);
        }
        return url.href;
    }
    /**
     * Prevent a function from blocking user interaction by delaying it until the browser is idle
     */
    static onIdle(fn) {
        return new Promise((resolve) => {
            const idleCallback = typeof window.requestIdleCallback === "function"
                ? window.requestIdleCallback
                : window.requestAnimationFrame;
            idleCallback(() => {
                resolve(fn());
            });
        });
    }
    static getInFlightRequest(requestKey) {
        return this.inFlightRequests.get(requestKey);
    }
    static onRequestDone(requestKey) {
        // Whenever a request is finished, it is removed from the in-flight requests map
        this.inFlightRequests.delete(requestKey);
        if (this.inFlightRequests.size === 0) {
            // When there are no more in-flight requests, the onAllRequestsComplete callbacks can
            // be called.
            this.onRequestsCompleteCallbacks.forEach((fn) => fn());
        }
    }
    /**
     * Attach a callback that runs when all in-flight requests are completed.
     */
    static onAllRequestsComplete(fn) {
        this.onRequestsCompleteCallbacks.push(fn);
    }
    /**
     * Attach a callback that runs when a request is made.
     */
    static onRequest(fn) {
        this.onRequestCallbacks.push(fn);
    }
}
// TODO: Using "any" here simplifies the usage downstream. Callers still get type safety with
// makeRequest<T>() and getInFlightRequest<T>().
// eslint-disable-next-line @typescript-eslint/no-explicit-any
RequestManager.inFlightRequests = new Map();
RequestManager.onRequestsCompleteCallbacks = [];
RequestManager.onRequestCallbacks = [];
export default RequestManager;
